module.exports = __webpack_public_path__ + "static/media/people.8bbb02b2.svg";